export default {
  notFound: {
    title: 'This page has not been generated',
    message: 'Tell me what you would like on this page',
    backHome: 'Back to home',
    contact: 'Go to contact',
  },
};